import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosPrestador from './FiltrosAdicionadosPrestador'
import FiltroPrestador from './FiltroPrestador'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroPrestador = () => (
  <Filtro PainelFiltro={FiltroPrestador}/>
);

const PainelFiltrosPrestador = () => (
  <PainelFiltragem
    Filtro={PainelFiltroPrestador}
    FiltrosAdicionados={FiltrosAdicionadosPrestador}/>
)

export default PainelFiltrosPrestador
